// filepath: c:\Users\gelis\Documents\GitHub\PisikolojiWeb\frontend\src\components\SEO\Meta.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords, schema, favicon, ogImage, ogType, canonicalUrl }) => {
  const defaultImage = "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758372063/pisikoloji_web/hep6j7kzjyq28gltfwj1.png";
  const siteUrl = "https://ssi.org.tr";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="SSI Association" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Favicon */}
      {favicon && <link key={favicon} rel="icon" type="image/png" href={favicon} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType || "website"} />
      <meta property="og:site_name" content="SSI Association" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@saborientee" />
      <meta name="twitter:creator" content="@saborientee" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || defaultImage} />
      
      {/* Additional SEO */}
      <meta name="theme-color" content="#3b82f6" />
      <meta name="msapplication-TileColor" content="#3b82f6" />
      
      {/* Geo Tags for Local SEO */}
      <meta name="geo.region" content="TR-16" />
      <meta name="geo.placename" content="Bursa, Turkey" />
      <meta name="geo.position" content="40.2128;28.9744" />
      <meta name="ICBM" content="40.2128, 28.9744" />
      
      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'SSI Association | Erasmus+ & EU Youth Projects Turkey',
  description: 'SSI Association is a leading Turkish NGO specializing in EU-funded projects: Erasmus+ Youth Exchanges, Training Courses, KA1 & KA2 programmes. Partner with us for international youth mobility.',
  keywords: 'Erasmus+ Turkey, EU projects, youth exchange, KA1 mobility, KA2 partnerships, European Solidarity Corps, youth NGO Turkey, international projects, training courses Europe',
  ogType: 'website',
  favicon: 'https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758372063/pisikoloji_web/hep6j7kzjyq28gltfwj1.png'
};

export default Meta;